module.exports = __webpack_public_path__ + "images/category_lp/watch/bg-customer_3efdb986a454de492ec285611c2eac2b.png";